




import { Component, Prop, Provide, Vue } from 'vue-property-decorator';

@Component
export default class MapProvider extends Vue {
    @Prop()
    google!: Object;
    @Prop()
    map!: google.maps.Map;

    @Provide() googleApi = this.google;
    @Provide() mapApi = this.map;
}
